<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Modify Good Return Voucher #{{data.code}}</h4>
                    <p class="text-subtitle-1">Good Return Voucher Creation Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <GoodReturnForm ref="form" v-model="data"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn block color="primary" @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import GoodReturnForm from './../../../components/purchase/GoodReturnForm.vue';
import service from './../../../services/purchase/goodReturn';
import PAlert from './../../../components/common/PAlert';

export default {
    components: {
        GoodReturnForm,
        PAlert
    },
    data() {
        return {
            dataLoading: false,
            loading: false,
            data: {},
            id: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
        }
    },
    methods: {
        fetchReturnNote() {
            this.dataLoading = true;
            service.get(this.id).then(response => {
                let d = response.data;
                this.data = {
                    date: d.date,
                    code: d.code,
                    warehouse: d.warehouse,
                    warehouse_id: d.warehouse ? d.warehouse.id : null,
                    purchase_order_id: d.purchase_order ? d.purchase_order.id : null,
                    purchase_order_code: d.purchase_order ? d.purchase_order.code : null,
                    state: d.state,
                    lines: d.lines.map(l => {
                        return {
                            item: l.item,
                            item_id: l.item ? l.item.id : null,
                            quantity: l.quantity,
                            measure_unit_id: l.measure_unit ? l.measure_unit.id : null
                        }
                    })
                }
            }).finally(() => {
                this.dataLoading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.save }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            service.update(this.id, this.data).then(response => {
                this.$router.replace({
                    name: "GoodReturnDisplay",
                    params: {
                        id: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, content: "Are you sure you want to discard changes?", value: true, callback: this.cancel }
        },
        cancel() {
            this.$router.back();
        },
    },
    created() {
        this.id = this.$route.params.id;
        this.fetchReturnNote();
    }
}
</script>

<style>

</style>